import { render, staticRenderFns } from "./ChaveValor.vue?vue&type=template&id=6a73e9b8&scoped=true"
import script from "./ChaveValor.vue?vue&type=script&lang=js"
export * from "./ChaveValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a73e9b8",
  null
  
)

export default component.exports